import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import ChevronDown from "../chevron/ChevronDown";
import ChevronUp from "../chevron/ChevronUp";
import avatar1 from "../../../assets/images/Avatar 2.png";
import threeDotsIcon from "../../../assets/images/three-dots.png";
import profilePic from "../../../assets/images/profile1.jpg";
import AddSubTeamModal from "./AddSubTeamModal";
import RemoveSubTeamModal from "./RemoveSubTeamModal";
import EditSubTeamModal from "./EditSubTeamModal";
import TeamTable from "./TeamTable";
import InvitesTeammatesModal from "./InvitesTeammatesModal";
import axios from "axios";

const SubTeams = ({ currentUser, DummyAvatarSvg, setIsLoading, props }) => {
  const s_teams = currentUser?.team?.sub_teams || [];

  const [showSubTeams, setShowSubTeams] = useState(false);
  const [magic_link, set_magic_link] = useState(null);
  const [membersInCurrentSubTeam, setMembersInCurrentSubTeam] = useState([]);
  const [show_sub_teams_modal, set_show_sub_teams_modal] = useState(false);
  const [remove_sub_team_modal, set_remove_sub_team_modal] = useState(null);
  const [edit_sub_team_modal, set_edit_sub_team_modal] = useState(null);
  console.log(edit_sub_team_modal, "set_edit_sub_team_modal==>");

  const [sub_teams, set_sub_teams] = useState([]);
  const [invite_modal, set_invite_modal] = useState(false);

  const [activeButton, setActiveButton] = useState("Teammates");

  const [filterTeammatesTable, setFilterTeammatesTable] = useState("Teammates");

  const [teamTableThreeDotDrpdwn, setTeamTableThreeDotDrpdwn] = useState(false);
  console.log(teamTableThreeDotDrpdwn, "teamTableThreeDotDrpdwn==>");

  const toggle_intive_modal = () => set_invite_modal(!invite_modal);
  const managTeamTableTooltipRef = useRef(null);
  // const box = useRef(null);
  // useOutsideAlerter(box);
  // function useOutsideAlerter(ref) {
  //   useEffect(() => {
  //     // Function for click event
  //     function handleOutsideClick(event) {
  //       if (ref.current && !ref.current.contains(event.target)) {
  //         alert("hllooooooo");
  //       }
  //     }

  //     // Adding click event listener
  //     document.addEventListener("click", handleOutsideClick);
  //     return () => document.removeEventListener("click", handleOutsideClick);
  //   }, [ref]);
  //   const tooltipRef = useRef(null);

  //   // Hook for handling clicks outside of the tooltip content
  //   useOutsideAlerter(tooltipRef, () => {
  //     // Close the tooltip content here
  //     const tempUsers = sub_teams.map((value) => ({
  //       ...value,
  //       tooltip: false,
  //     }));
  //     set_sub_teams(tempUsers);
  //   });
  // }
  const handleTeammatesButtonClick = () => {
    if (activeButton !== "Teammates") {
      setActiveButton("Teammates");
      setFilterTeammatesTable("Teammates");
    }
  };

  const handleTeamsButtonClick = () => {
    if (activeButton !== "Teams") {
      setActiveButton("Teams");
      setFilterTeammatesTable("Teams");
    }
  };
  const getMagicLink = () => {
    setIsLoading(true);
    let url = process.env.REACT_APP_GET_MAGIC_LINK;
    url = `${url}?team_code=${currentUser.team.id}&user_name=${currentUser?.username}`;
    axios({
      method: "GET",
      url
    })
      .then((data) => {
        setIsLoading(false);
        set_magic_link(data.data.url);
        toggle_intive_modal();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err, "errerr");
      });
  };

  useEffect(() => {
    const handleClickOutsideManage = (event) => {
      if (
        teamTableThreeDotDrpdwn &&
        managTeamTableTooltipRef.current &&
        !managTeamTableTooltipRef.current.contains(event.target)
      ) {
        console.log("clickedOutside");
        setTeamTableThreeDotDrpdwn(false);
      }
    };

    document.addEventListener("click", handleClickOutsideManage);

    return () => {
      document.removeEventListener("click", handleClickOutsideManage);
    };
  }, [teamTableThreeDotDrpdwn]);

  useEffect(() => {
    const users = currentUser?.team?.users || [];
    let temp = s_teams.map((item) => {
      const res = {
        sub_name: item.sub_name,
        tooltip: false
      };
      const admin_details =
        users.find((user) => user.Username == item.admin) || {};
      res.admin = {
        user_id: item.admin,
        email: admin_details?.email,
        name: admin_details?.name,
        picture: admin_details?.picture
      };
      res.members = item.members.map((u_id) => {
        const user_details =
          users.find((user) => (user.user_ids || user.Username) == u_id) || {};
        return {
          ...user_details
        };
      });
      return res;
    });

    const unassigned_team = {
      sub_name: "Default (Unassigned)",
      tooltip: false
    };
    const team_admin_details =
      users.find((user) => user.Username == currentUser.team.manager) || {};
    unassigned_team.admin = {
      user_id: currentUser.team.manager,
      email: team_admin_details?.email,
      name: team_admin_details?.name,
      picture: team_admin_details?.picture
    };
    const unassigned_users = users.filter((user) => !user.sub_team);
    unassigned_team.members = unassigned_users;
    temp = [unassigned_team, ...temp];
    set_sub_teams(temp);
  }, [JSON.stringify(s_teams)]);

  const toggle_sub_teams_modal = () => {
    set_show_sub_teams_modal(!show_sub_teams_modal);
  };

  const handle_sub_team_tooltip_toggle = (item) => {
    const temp_users = [...sub_teams];
    const array = temp_users.map((value) =>
      value.sub_name === item.sub_name
        ? { ...value, tooltip: true }
        : { ...value, tooltip: false }
    );
    console.log(array, "array");
    set_sub_teams(array);
    setTeamTableThreeDotDrpdwn(true);
  };

  console.log(teamTableThreeDotDrpdwn, "teamTableThreeDotDrpdwn");
  return (
    <>
      {!!invite_modal && (
        <InvitesTeammatesModal
          currentUser={currentUser}
          invite_modal={invite_modal}
          toggle_intive_modal={toggle_intive_modal}
          magic_link={magic_link}
        />
      )}
      {show_sub_teams_modal && (
        <AddSubTeamModal
          show_sub_teams_modal={show_sub_teams_modal}
          toggle_sub_teams_modal={toggle_sub_teams_modal}
          currentUser={currentUser}
          DummyAvatarSvg={DummyAvatarSvg}
        />
      )}
      {remove_sub_team_modal && (
        <RemoveSubTeamModal
          remove_sub_team_modal={remove_sub_team_modal}
          set_remove_sub_team_modal={set_remove_sub_team_modal}
          set_edit_sub_team_modal={set_edit_sub_team_modal}
          currentUser={currentUser}
          DummyAvatarSvg={DummyAvatarSvg}
        />
      )}
      {edit_sub_team_modal && (
        <EditSubTeamModal
          membersInCurrentSubTeam={membersInCurrentSubTeam}
          set_remove_sub_team_modal={set_remove_sub_team_modal}
          edit_sub_team_modal={edit_sub_team_modal}
          set_edit_sub_team_modal={set_edit_sub_team_modal}
          currentUser={currentUser}
          DummyAvatarSvg={DummyAvatarSvg}
        />
      )}

      {!edit_sub_team_modal &&
        !show_sub_teams_modal &&
        !remove_sub_team_modal && (
          <section className="manage-team">
            {/* <Container>
          <div className="invite-team">
            <h5 className="heading">Share this link to invite your team </h5>
            <p className="para">
              Teammates can use this link to sign up and join your team.
              (Expires in 72 hours):
            </p>
            <div className="invite-team__flex">
              <div className="input">
                <input
                  type="text"
                  name="link"
                  placeholder="https://play.gameapart.com/game-select/3209u9u9923"
                />
              </div>
              <button className="copy-link">Copy Link</button>
              <button className="share-link">Share Link</button>
            </div>
            <img src={closeIcon} className="closeIcon" alt="icon" />
          </div>
        </Container> */}
            <Container>
              <Row>
                <Col md={12}>
                  <div className="manage-team-data">
                    <div className="hide-show-teams">
                      {/* <div
                    className="toggle"
                    onClick={() => setShowSubTeams(!showSubTeams)}
                  >
                    {showSubTeams ? (
                      <>
                        <span>Hide Sub-Teams</span> <ChevronDown />
                      </>
                    ) : (
                      <>
                        <span>View Sub-Teams</span> <ChevronUp />
                      </>
                    )}
                  </div> */}
                      <div className="toggle">All Teammates</div>

                      <div className="create_team gap-3 d-flex">
                        <Button
                          color="primary"
                          className="new-team-btn outlined mr-4 gap-5"
                          onClick={toggle_sub_teams_modal}
                        >
                          Create New Team
                        </Button>
                        <Button
                          color="primary"
                          className="new-team-btn"
                          onClick={getMagicLink}
                        >
                          Invite Teammates
                        </Button>
                      </div>
                    </div>
                    <div className="mb-2">
                      <Button
                        color="primary"
                        className={`button1 ${
                          activeButton === "Teammates" ? "active" : "button2"
                        }`}
                        onClick={handleTeammatesButtonClick}
                      >
                        Teammates
                      </Button>
                      <Button
                        color="primary"
                        className={`button1 ${
                          activeButton === "Teams" ? "active" : "button2"
                        }`}
                        onClick={handleTeamsButtonClick}
                      >
                        Team
                      </Button>
                    </div>
                    {filterTeammatesTable === "Teammates" ? (
                      <TeamTable
                        currentUser={currentUser}
                        setIsLoading={setIsLoading}
                        DummyAvatarSvg={DummyAvatarSvg}
                      />
                    ) : (
                      <section className="my-team-new-table">
                        <Container>
                          <Row>
                            <Col md={12}>
                              <div className="kkkk">
                                <div className="header manage-team-header">
                                  <div className="table-header">
                                    <div className="teammate">Team Name</div>
                                    <div className="email">Admin</div>
                                    <div className="team">Teammates</div>
                                    <div className="blank-box"></div>
                                  </div>
                                </div>
                                {sub_teams.map((s_team, index) => (
                                  <div
                                    className="team-data-wrapper"
                                    key={index}
                                  >
                                    <div
                                      className={`team-data ${
                                        index == sub_teams.length - 1 &&
                                        "team-data-last"
                                      }`}
                                    >
                                      <div className="email-col">
                                        <p className="txt mb-0">
                                          {s_team?.sub_name}
                                        </p>
                                      </div>
                                      <div className="teammate-col">
                                        {s_team?.admin?.picture ? (
                                          <img
                                            src={s_team?.admin?.picture}
                                            alt=""
                                          />
                                        ) : (
                                          <DummyAvatarSvg className="avatar" />
                                        )}
                                        <p className="mb-0">
                                          {s_team?.admin?.name}
                                        </p>
                                      </div>
                                      <div className="teammate2-col">
                                        <div className="teammate2-col-flex circular-images">
                                          <div>
                                            {s_team?.members?.map(
                                              (item, index) => {
                                                console.log(
                                                  s_team,
                                                  "itemitem==>"
                                                );
                                                if (index < 5) {
                                                  if (item.picture) {
                                                    return (
                                                      <img
                                                        src={
                                                          item.picture ||
                                                          avatar1
                                                        }
                                                        className={`img-fluid ${
                                                          s_team?.members
                                                            ?.length > 3 &&
                                                          "overlaped"
                                                        }`}
                                                        alt=""
                                                        key={index}
                                                      />
                                                    );
                                                  } else {
                                                    return (
                                                      <DummyAvatarSvg
                                                        className={`img-fluid img-svg ${
                                                          s_team?.members
                                                            ?.length > 3 &&
                                                          "overlaped"
                                                        }`}
                                                        key={index}
                                                      />
                                                    );
                                                  }
                                                }
                                              }
                                            )}
                                          </div>
                                          <p className="mb-0">
                                            {s_team?.members?.length || 0}{" "}
                                            Teammates
                                          </p>
                                        </div>
                                      </div>
                                      {s_team?.sub_name !==
                                      "Default (Unassigned)" ? (
                                        <div
                                          className="text-center w-100 three-dots"
                                          onClick={() => {
                                            handle_sub_team_tooltip_toggle(
                                              s_team
                                            );
                                          }}
                                        >
                                          <img src={threeDotsIcon} alt="" />
                                          {s_team.tooltip &&
                                            teamTableThreeDotDrpdwn && (
                                              <div
                                                className="tooltip-content"
                                                ref={managTeamTableTooltipRef}
                                              >
                                                <ul>
                                                  <li
                                                    onClick={() => {
                                                      set_edit_sub_team_modal(
                                                        s_team
                                                      );
                                                    }}
                                                  >
                                                    Edit
                                                  </li>
                                                  <li
                                                    onClick={() => {
                                                      set_remove_sub_team_modal(
                                                        s_team
                                                      );
                                                    }}
                                                  >
                                                    Remove
                                                  </li>
                                                </ul>
                                              </div>
                                            )}
                                        </div>
                                      ) : (
                                        // <div className="empty-div">dsd</div>
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </section>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        )}
    </>
  );
};

export default SubTeams;
